var map = {
	"./en-gb": 567,
	"./en-gb.js": 567
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1304;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en-gb
// module id = 1304
// module chunks = 1